import { render, staticRenderFns } from "./report-widget.vue?vue&type=template&id=9a71d830"
import script from "./report-widget.vue?vue&type=script&lang=js"
export * from "./report-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports